import { Machine } from '../../ts/Connections';
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { 
    getCustomFields, 
    parseBoolean,
    retrieveCertification, 
    parseListDirectoryResponse, 
    getCommodityList, 
    Commodity, 
    SubItem,
    CommodityDeterminationType,
    SpectreRequest,
    DimensionRequest,
    UploadRequest,
    CommodityRecord,
    ExportRequest,
    DimensionAndUploadRequest,
    UploadAndExportRequest,
    DimensionUploadAndExportRequest
} from '../../ts/Common';
import { encode, trim } from 'url-safe-base64';
import { Grid, Typography } from '@mui/material'
import Bowser from 'bowser';
import { useTranslation } from 'react-i18next';
import CenterControl from './Details/CenterControl';
import ScanHistory from './History/ScanHistory';
import ScanHistoryMobile from './History/ScanHistoryMobile';
import ScanHistoryDrawer from './History/ScanHistoryDrawer';
import Inputs from './Inputs/Inputs';
import SelectForkliftModal from './components/selectForkliftComponents/SelectForkliftModal';
import { Cargo } from '../../ts/Cargo';
import { checkMachineResponse } from '../../ts/MachineResponseParser';
import _ from 'lodash'
import { MachineEvent, NotificationCategory, TextEventProps } from '../../ts/MachineEvent';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ReportIcon from '@mui/icons-material/Report';
import { useAlert } from '../../AlertContext';
import { AprilTag, AprilTagsResponse } from '../../ts/AprilTag';
import { playAudio } from '../../utils/Audio';
import { SpectreResponse } from '../../ts/SpectreResponse';
const errorSound = new Audio("https://cargospectre.blob.core.windows.net/assets/sounds/error.mp3");
const successSound = new Audio("https://cargospectre.blob.core.windows.net/assets/sounds/success.mp3");
const MAX_SCAN_LIMIT = 10;
const MY_HOST = import.meta.env.VITE_MY_HOST || "https://spectre-licensing.com"

export default function Control(props: any) {

        // Handler for re-upload
        const handleReupload = async (cargoResponse: Cargo) => {
            if (!cargoResponse?.cargoFolder) return;
            try {
                const response = await machine.connection.post({
                    Requests: {
                        Upload: {
                            RecallDirectoryName: cargoResponse.cargoFolder
                        }
                    }
                });
                // Parse the response into the correct Cargo object
                if (cargoResponses[selectedScanIndex]) {
                    cargoResponses[selectedScanIndex].parseResponse(response, 'Upload');
                    // Force update state to trigger re-render
                    setCargoResponses([...cargoResponses]);
                }
            } catch (error) {
                genericAlert(error instanceof Error ? error : new Error('Re-upload failed'));
            }
        };

        // Handler for re-export
        const handleRexport = async (cargoResponse: Cargo) => {
            if (!cargoResponse?.cargoFolder) return;
            try {
                const response = await machine.connection.post({
                    Requests: {
                        Export: {
                            RecallDirectoryName: cargoResponse.cargoFolder
                        }
                    }
                });
                // Parse the response into the correct Cargo object
                if (cargoResponses[selectedScanIndex]) {
                    cargoResponses[selectedScanIndex].parseResponse(response, 'Export');
                    setCargoResponses([...cargoResponses]);
                }
            } catch (error) {
                genericAlert(error instanceof Error ? error : new Error('Re-export failed'));
            }
        };
    const { machine, showMachineSettings, setShowMachineSettings, showCalibration, setShowCalibration, showSupport, setShowSupport, showCertification, setShowCertification, onlineMachines, setSelectedMachine, machineEvents, setMachineEvents, user, mobileNavbarOpen, settingsLoaded, setSettingsLoaded } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [customFields, setCustomFields] = useState<JSON[]>([]);
    const [customFieldDropDownValues, setCustomFieldDropDownValues] = useState<JSON[]>([]);
    const [customFieldSubmitValues, setCustomFieldSubmitValues] = useState<any>({});
    const [customFieldSubmitValuesEmpty, setCustomFieldSubmitValuesEmpty] = useState<Object>({});
    const [clearCustomFieldsAfterUpload, setClearCustomFieldsAfterUpload] = useState<boolean>(false);
    const [barcodeValue, setBarcodeValue] = useState<string>("");
    const [cargoResponses, setCargoResponses] = useState<Cargo[]>([]);
    const [machineCommand, setMachineCommand] = useState<string>("dimension");
    const [machineActive, setMachineActive] = useState<boolean>(false);
    const [customFieldsLoaded, setCustomFieldsLoaded] = useState<boolean>(false);
    const [disableScanButton, setDisableScanButton] = useState<boolean>(false);
    const [selectedScanIndex, setSelectedScanIndex] = useState(0);
    const [settings, setSettings] = useState<any>({});
    const [openScanDetails, setOpenScanDetails] = useState<boolean>(false);
    const [scanButtonPressed, setScanButtonPressed] = useState<boolean>(false);
    const [customFieldsReadyForSubmission, setCustomFieldsReadyForSubmission] = useState<boolean>(false);
    const [MachineSwapWithScanner, setMachineSwapWithScanner] = useState<boolean>(false);
    const [dimensionerMode, setDimensionerMode] = useState<string>("");
    const [lastParsedScanTime, setLastParsedScanTime] = useState<string>("");
    const [certification, setCertification] = useState<boolean>(false);
    const [openForkliftModal, setOpenForkliftModal] = useState<boolean>(false);    
    const [commodities, setCommodities] = useState<CommodityRecord[]>([]);
    const [commoditiesLoaded, setCommoditiesLoaded] = useState<boolean | null>(false);
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
    const [selectedCommodity, setSelectedCommodity] = useState<Commodity | null>(null);
    const [selectedSubItem, setSelectedSubItem] = useState<SubItem | null>(null);
    const [forkliftList, setForkliftList] = useState<AprilTag[]>([]);
    const [forklift, setForklift] = useState<AprilTag | null>(null);
    const { openAlert } = useAlert();
    const passiveModes = import.meta.env.VITE_INCLUDE_PARCEL_MODE === 'true' 
        ? ['Rollthru', 'Parcel'] 
        : ['Rollthru'];
    const forkliftModalShownRef = useRef<boolean>(false);
    const [pendingBarcode, setPendingBarcode] = useState<string | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [consecutiveListDirectoryFailures, setConsecutiveListDirectoryFailures] = useState<number>(0);
    const listDirectoryFailureAlertShownRef = useRef<boolean>(false);
    const [clearPhotosSignal, setClearPhotosSignal] = useState<number>(0);

    const genericAlert = (error: Error = new Error("Unknown error occurred"), severity: 'warning' | 'error' | 'info' = 'error', showCancelButton: boolean = false) => {
        openAlert(
            t('alertContext.pingFailure.title'),
            t('alertContext.pingFailure.message'),
            t('alertContext.back'),
            () => {
                navigate('/matchmaking')
            },
            showCancelButton,
            error,
            {
                component: "Control",
                action: "Ping",
                machineVersion: machine?.version ?? "Unknown version",
                connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
            },
            severity
        );
    }

    // simple function to check if the browser is Safari
    // This is used to determine if we need to use a different method for playing sounds
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isSafariMobile = browser.getBrowserName() === 'Safari' && browser.getPlatformType() === 'mobile' 

    useEffect(() => {
        setDimensionerMode("");
        setCargoResponses([]);
        try {
            machine.connection.ping()
                .then((response: boolean) => {
                    if (!response) {
                        genericAlert();
                        return;
                    } else {
                        return machine.loadSettings()
                        .then(() => {
                            getCustomFields()
                                .then((data) => {
                                    data.customFieldValues.length > 0 ? setCustomFields(data.customFieldValues) : setCustomFields([]);
                                    data.customFieldDropDownValues.length > 0 ? setCustomFieldDropDownValues(data.customFieldDropDownValues) : setCustomFieldDropDownValues([]);
                                    setCustomFieldsLoaded(true)
                                    return customFields
                                })
                                .catch((error: Error) => {
                                    genericAlert(new Error("Unable to retrieve custom fields"));
                                })
                            retrieveCertification(machine)
                                .then((response) => {
                                    const certificationResponse = response?.['Responses']?.['GetCertification'];
                                    if (certificationResponse && certificationResponse['code'] === '0') {
                                        machine.certification = response?.['Responses']?.['GetCertification']
                                        setCertification(true);
                                    } else {
                                        genericAlert(new Error("Unable to retrieve certification"), 'error', true);
                                    }
                                })
                                .catch((error: Error) => {
                                    genericAlert(error);
                                })
                            getCommodityList()
                                .then((data) => {
                                    data.length > 0 ? setCommodities(data) : setCommodities([]);
                                    setCommoditiesLoaded(true);
                                    return commodities;
                                })
                                .catch((error: Error) => {
                                    setCommoditiesLoaded(null);
                                })
                        })
                    }
                })
                .catch((error: Error) => {
                    console.log('ping error', error);
                    openAlert(
                        t('alertContext.pingFailure.title'),
                        t('alertContext.pingFailure.message'),
                        t('alertContext.back'),
                        () => {
                            navigate('/matchmaking')
                        },
                        false,
                        undefined,
                        {
                            component: "Control",
                            action: "Ping",
                            machineVersion: machine?.version ?? "Unknown version",
                            connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                        }
                    );
                })
        }
        catch (error) {
            const typedError = error instanceof Error ? error : undefined;
            openAlert(
                t('alertContext.connectionLost.title'),
                t('alertContext.connectionLost.message'),
                t('alertContext.back'),
                () => {
                    navigate('/matchmaking')
                },
                false,
                typedError,
                {
                    component: "MachineSettings",
                    action: "",
                    machineVersion: machine?.version ?? "Unknown version",
                    connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machine]);

    // Reset failure count when machine changes
    useEffect(() => {
        setConsecutiveListDirectoryFailures(0);
        listDirectoryFailureAlertShownRef.current = false;
    }, [machine]);

    useEffect(() => {
        if (settingsLoaded && dimensionerMode === "Passive") {
            fetch(`${MY_HOST}/api/RemoteDevice/List/${machine.location}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
            })
            .then(response => response.json())
            .then((data: AprilTagsResponse) => {  
                if (data && data.aprilTags) {
                    const forkliftObjects = data.aprilTags.map((tag: AprilTag ) => ({
                        ...tag,
                        tagValue: tag.tagValue
                    }));
                    setForkliftList(forkliftObjects);
                    // Only open the modal on initial page load
                    if (!forkliftModalShownRef.current) {
                        setOpenForkliftModal(true);
                        forkliftModalShownRef.current = true;
                    }
                } else {
                    console.warn("No remote devices found in the response.");
                }
            })
            // Retrieve certification after machines are switched in Passive mode
            .then(() => {
                return retrieveCertification(machine)
                .then((response) => {
                    if (response?.['Responses']?.['GetCertification']?.['code'] === '0') {
                        machine.certification = response?.['Responses']?.['GetCertification']
                        setCertification(true);
                    }
                });
            })
            .then(() => {
                return machine.connection.get(`ListDirectory?InlineInfo=true&OrderByRecent=true&Count=5`)
                    .then((response: { Responses: { ListDirectory: { Directory: { iso8601: string }[] } } }) => {
                        if (response?.Responses?.ListDirectory?.Directory && response.Responses.ListDirectory.Directory.length > 0) {
                            setLastParsedScanTime(response.Responses.ListDirectory.Directory[0].iso8601);
                            setCargoResponses(parseListDirectoryResponse(response, machine));
                        } else {
                            console.warn("No directory entries found in ListDirectory response");
                            // Set a default timestamp if no entries exist
                            setLastParsedScanTime(new Date().toISOString());
                            setCargoResponses([]);
                        }
                    });
            })
            .catch((error) => {
                console.error('Error fetching network scales:', error);
                openAlert(
                    t('alertContext.pingFailure.title'),
                    t('alertContext.pingFailure.message'),
                    t('alertContext.back'),
                    () => {
                    navigate('/matchmaking')
                    },
                    false,
                    error,
                    {
                    component: "Control",
                    action: "Rollthru retrieve Networkscale & Certification ",
                    machineVersion: machine?.version ?? "Unknown version",
                    connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                    },
                    'error'
                );
            });
        }
    }, [dimensionerMode, settingsLoaded, machine])

    useEffect(() => {
        let intervalId: NodeJS.Timeout;
        if (dimensionerMode === "Passive" && settingsLoaded && lastParsedScanTime !== "") {
            intervalId = setInterval(() => {
                (machine as Machine).connection.get(`ListDirectory?InlineInfo=true&OrderByRecent=true&Begin=${lastParsedScanTime}`)
                    .then((response: any) => {
                        if (response['error'] === "Fetch error") {
                            console.log("Fetch error, reattempting")
                            setConsecutiveListDirectoryFailures(prev => {
                                const newFailureCount = prev + 1;

                                // Show alert after 5 consecutive failures, but only once until success
                                if (newFailureCount >= 5 && !listDirectoryFailureAlertShownRef.current) {
                                    listDirectoryFailureAlertShownRef.current = true;
                                    openAlert(
                                        t('alertContext.connectionLost.title'),
                                        t('alertContext.passiveModeConnectionFailure.message', { 
                                            count: newFailureCount,
                                            defaultValue: `Machine connection lost after ${newFailureCount} failed attempts. The machine may be frozen or offline. You can go back to select a different machine or dismiss this alert to continue monitoring this machine.`
                                        }),
                                        t('alertContext.disconnect'),
                                        () => {
                                            navigate('/matchmaking')
                                        },
                                        true, // Show cancel button to allow dismissing the alert
                                        new Error(`Fetch error - ${newFailureCount} consecutive failures`),
                                        {
                                            component: "Control",
                                            action: "Rollthru list directory - consecutive failures",
                                            machineVersion: machine?.version ?? "Unknown version",
                                            connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                                            consecutiveFailures: newFailureCount,
                                        },
                                        'error'
                                    );
                                }
                                
                                return newFailureCount;
                            });
                            return;
                        }
                        
                        // Reset failure count on successful response (not a fetch error)
                        setConsecutiveListDirectoryFailures(0);
                        listDirectoryFailureAlertShownRef.current = false;
                        
                        if (response?.['Responses']?.['ListDirectory']?.['Directory']?.length === 1) {
                            console.log('no new scans found, reattempting');
                            return;
                        } else if (response?.['Responses']?.['ListDirectory']?.['Directory']?.length > 1) {
                            response?.['Responses']?.['ListDirectory']?.['Directory']?.pop();
                            setLastParsedScanTime(response?.['Responses']?.['ListDirectory']?.['Directory']?.[0]?.['iso8601']);
                            let latestScans = parseListDirectoryResponse(response, machine);
                            cargoResponses.length > MAX_SCAN_LIMIT ? setCargoResponses([...latestScans, ...cargoResponses.slice(0, Math.min(MAX_SCAN_LIMIT, Math.max(0, MAX_SCAN_LIMIT - latestScans.length)))]) : setCargoResponses([...latestScans, ...cargoResponses]);
                        } else if (response?.['Responses']?.['ListDirectory']?.['code'] !== "0") {  
                            console.warn("ListDirectory response is undefined or null.");
                        } else {
                            console.warn("ListDirectory response is undefined or empty.");
                        }
                    })
                    .catch((err: Error) => {
                        // This catch block handles unexpected errors that don't go through the defaultErrorResponse
                        console.log('Failed to list directory - unexpected error', err);
                        setConsecutiveListDirectoryFailures(prev => prev + 1);
                        openAlert(
                            t('alertContext.pingFailure.title'),
                            t('alertContext.pingFailure.message'),
                            t('alertContext.back'),
                            () => {
                                navigate('/matchmaking')
                            },
                            false,
                            err,
                            {
                                component: "Control",
                                action: "Rollthru list directory",
                                machineVersion: machine?.version ?? "Unknown version",
                                connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                            }
                        );
                    })
            }, 2000);
            return () => clearInterval(intervalId);
        }
        if (dimensionerMode !== "Passive") {
            // Reset failure count when not in passive mode
            setConsecutiveListDirectoryFailures(0);
            listDirectoryFailureAlertShownRef.current = false;
            return () => clearInterval(intervalId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastParsedScanTime, dimensionerMode, navigate, openAlert, t, machine]);

    useEffect(() => {
        if (settingsLoaded && certification) {
            setClearCustomFieldsAfterUpload(settings.Scanner.ClearCustomFields.value)
            setMachineSwapWithScanner(settings.Scanner.MachineSwapWithScanner.value)
            // checks if the settings.Scanner.Mode.value is included in the provided Array, if so, set Passive mode
            // If a "Parcel RollThru" is added in the future we can add it in here to check rather than creating new states. 
            if (passiveModes.includes(settings.Scanner.Mode.value)) {
                setDimensionerMode("Passive")
            } else {
                setDimensionerMode("Active")
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showMachineSettings, machine, settingsLoaded, certification])

    useEffect(() => {
        if (_.get(settings, 'Calibration.Path.value') === "") {
            setDisableScanButton(true);
            openAlert(
                t('control.calibration.uncalibrated.title'),
                t('control.calibration.uncalibrated.message'),
                t('alertContext.ok'),
                () => {},
                false,
                new Error("Machine not calibrated - please calibrate to enable scanning"),
                {
                    component: "Control",
                    action: "machineScan",
                    machineVersion: machine?.version ?? "Unknown version",
                    connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                },
                'error'
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settingsLoaded])

    useEffect(() => {
        // Check on scan button press for machine name match
        if (scanButtonPressed && MachineSwapWithScanner && barcodeValue.startsWith('SPECTRE:')) {
            setMachineActive(true);
            const swapCandidate = barcodeValue.split(':')[1];
            if (swapCandidate === machine.machineName) {
                const switchEvent = new TextEventProps();
                switchEvent.icon = ReportIcon;
                switchEvent.subject = 'Ignored attempt to switch to same machine:';
                switchEvent.message = machine.machineName;
                switchEvent.category = NotificationCategory.INFO;
                setMachineEvents([...machineEvents, switchEvent])
                setScanButtonPressed(false);
                setMachineActive(false);
                return;
            }

            const promises = [];
            for (let i = 0; i < onlineMachines.length; i++) {
                if (barcodeValue === 'SPECTRE:' + onlineMachines[i].machineName) {
                    promises.push(onlineMachines[i].connection.ping()
                        .then((response: boolean) => {
                            if (!response) {
                                const switchEvent = new TextEventProps();
                                switchEvent.icon = ReportIcon;
                                switchEvent.subject = 'Failed to switch to:';
                                switchEvent.message = onlineMachines[i].machineName;
                                switchEvent.category = NotificationCategory.WARNING;
                                setMachineEvents([...machineEvents, switchEvent])
                                setScanButtonPressed(false);
                                return false;
                            }
                            else {
                                setSelectedMachine(onlineMachines[i]);
                                setBarcodeValue('');
                                const switchEvent = new TextEventProps();
                                switchEvent.icon = SwapHorizIcon;
                                switchEvent.subject = 'Switched to:';
                                switchEvent.message = onlineMachines[i].machineName;
                                switchEvent.category = NotificationCategory.PRIMARY;
                                setMachineEvents([switchEvent])
                                setScanButtonPressed(false);
                                return true;
                            }
                        })
                        .catch(() => {
                            return false;
                        })
                    );
                }
            }
            Promise.all(promises).then((promiseResults: boolean[]) => {
                if (!promiseResults.includes(true)) {
                    const switchEvent = new TextEventProps();
                    switchEvent.icon = ReportIcon;
                    switchEvent.subject = `Failed to switch to:`;
                    switchEvent.message = swapCandidate;
                    switchEvent.category = NotificationCategory.WARNING;
                    setMachineEvents([...machineEvents, switchEvent])
                    setScanButtonPressed(false);
                }
            });
            setMachineActive(false);
            return;
        }

        // Two checks - one for users with custom fields, and one for users without custom fields. 
        if ((scanButtonPressed === true && customFieldsReadyForSubmission === true) || (scanButtonPressed === true && !customFieldSubmitValues?.['CustomFields']?.['Field']?.length)) {
            if ('AutoBarcodeDelay' in settings.Scanner) {
                let triggerDelay = settings.Scanner.AutoBarcodeDelay.value;
                if (triggerDelay && !isNaN(triggerDelay) && triggerDelay > 0) {
                    setTimeout(function () {
                        machineScan(`${machineCommand}`)
                    }, Number(triggerDelay) * 1000)
                } else {
                    machineScan(`${machineCommand}`)
                }
            } else {
                machineScan(`${machineCommand}`)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scanButtonPressed, customFieldsReadyForSubmission])

    const checkCustomFieldsReady = function () {
        const checker = (arr: any) => arr.every((element: any) => element['Ready'] === true);
        if (customFieldSubmitValues?.['CustomFields']?.['Field']?.length) {
            // checks that every custom field has it's "Ready" status set to true, if true, setCustomFIeldsReadyForSubmission to True
            if (checker(customFieldSubmitValues['CustomFields']['Field'])) {
                setCustomFieldsReadyForSubmission(true)
            } else {
                setCustomFieldsReadyForSubmission(false);
            }
        } else {
            setCustomFieldsReadyForSubmission(true);
        }
    }

    // runs through custom fields and sets Auto Increment field ready state to false
    const resetCustomFieldsReady = function () {
        let customFieldsSubmitValuesCopy = { ...customFieldSubmitValues };
        if (customFieldsSubmitValuesCopy?.['CustomFields']?.['Field']?.length) {
            customFieldsSubmitValuesCopy['CustomFields']['Field'].forEach((field: any) => {
                field['FieldType'] === 4 ? field['Ready'] = false : field['Ready'] = true
            });
            setCustomFieldSubmitValues(customFieldsSubmitValuesCopy);
        }
    }

    async function machineScan(cmd: string) {
        const request = commands[cmd]();
        if ('Dimension' in request.Requests && customFieldSubmitValues?.['CustomFields']?.['Field']) {
            for (let i = 0; i < customFieldSubmitValues['CustomFields']['Field'].length; i++) {
                if (customFieldSubmitValues['CustomFields']['Field'][i]['Required'] && !customFieldSubmitValues['CustomFields']['Field'][i]['Value']) {
                    alert('A required custom field was not filled in. Your organization has a custom field that was marked as required on every scan. \n\nPlease check for any fields marked with a red asterisk(*) and make sure they are filled in prior to pressing the Scan button.')
                    setScanButtonPressed(false);
                    return;
                }
            }
        }

        if ('Dimension' in request.Requests) {
            const incompleteMachineEvent = new MachineEvent();
            incompleteMachineEvent.complete = false;
            setMachineEvents([incompleteMachineEvent, ...machineEvents])
        }
        setMachineActive(true);

        return await machine.connection.post(commands[cmd](barcodeValue !== ""))
            .then((response: SpectreResponse) => {
                const currentRequest = commands[cmd]();
                if ('Dimension' in currentRequest.Requests) {
                    let machineEventsCopy = [...machineEvents];
                    machineEventsCopy.pop();
                    setMachineEvents(machineEventsCopy);
                }

                // Check if this was a successful Dimension event - signal to clear photos
                if (response.Responses?.Dimension?.code === "0") {
                    setClearPhotosSignal(prev => prev + 1);
                }

                setBarcodeValue("")
                setMachineActive(false);
                const shouldPlaySound = parseBoolean(settings.Scanner.PlaySoundAfterScanning.value);
                // sets the selected scan back to 0 index on each new scan
                setScanButtonPressed(false)
                setCustomFieldsReadyForSubmission(false)
                setSelectedScanIndex(0)
                // handle Dimension responses
                if (checkMachineResponse(response, 'Dimension')) {
                    const cargo = new Cargo(machine.certification, customFieldSubmitValues);
                    cargo.parseResponse(response, cmd)
                    if (!isSafariMobile) {
                        if (shouldPlaySound && (cargo.uploaded === false || cargo.dimensionCode !== "0" || cargo.exported === false)) {
                            playAudio(errorSound);
                        } else if (shouldPlaySound) {
                            playAudio(successSound);
                        }
                    }
                    // Check freight class limits if a commodity is selected
                    if (selectedCommodity && cargo.dimensions.freightClass?.class) {
                        checkFreightClassLimits(cargo);
                    }
                    
                    cargoResponses.length > MAX_SCAN_LIMIT ? setCargoResponses([cargo, ...cargoResponses.slice(0, MAX_SCAN_LIMIT)]) : setCargoResponses([cargo, ...cargoResponses])
                } else if (!response || cargoResponses?.length === 0) {
                    // handle communication timeout for defaultErrorResponse() in connections.tsx
                    genericAlert();
                } else if (cargoResponses?.length > 0) {
                    cargoResponses[0].parseResponse(response, cmd)
                    setCargoResponses([...cargoResponses])
                } else {
                    genericAlert();
                }
                if (checkMachineResponse(response, 'Upload')) {
                    clearCustomFieldsAfterUpload ? setCustomFieldSubmitValues({ ...customFieldSubmitValuesEmpty }) : resetCustomFieldsReady();
                } else {
                    resetCustomFieldsReady();
                }
            })
            .catch((err: any) => {
                if (!isSafariMobile) {
                    playAudio(errorSound);
                }
                setBarcodeValue("")
                setMachineActive(false);
                setScanButtonPressed(false);
                setCustomFieldsReadyForSubmission(false)

                const rawErrMessage =
                    err && typeof err === 'object' && 'message' in err && (err as any).message
                        ? String((err as any).message)
                        : typeof err === 'string'
                            ? err
                            : '';
                const errorMessage =
                    t('control.scan.error.message') +
                    (rawErrMessage ? `\n\n${rawErrMessage}` : "");
                const normalizedError =
                    err instanceof Error
                        ? err
                        : new Error(rawErrMessage || "Unknown scanning error");

                openAlert(
                    t('control.scan.error.title'),
                    errorMessage,
                    t('alertContext.ok'),
                    () => {},
                    false,
                    normalizedError,
                    {
                        component: "Control",
                        action: "machineScan",
                        machineVersion: machine?.version ?? "Unknown version",
                        connectionEndpoint: machine?.connection?.ip ?? "Unknown IP",
                    },
                    'error'
                );
                
                checkCustomFieldsReady();
                resetCustomFieldsReady();
                console.log('communication error', err)
            })
        };
    // Form submission helpers
    const encodeCustomFields = function () {
        if (customFields.length === 0) {
            return ""
        }
        let encodedFields = btoa(JSON.stringify(customFieldSubmitValues));
        encodedFields = encode(encodedFields);
        return trim(encodedFields);
    }

    // Helper function to add freight class data to dimension requests
    const addFreightClassToRequest = function(request: SpectreRequest) {
        if (selectedCommodity && 'Dimension' in request.Requests) {
            if (selectedCommodity.determinedBy === CommodityDeterminationType.MATERIAL && selectedSubItem) {
                // Material-determined with specific subItem selected
                request.Requests.Dimension.Class = {
                    "CommodityID": selectedCommodity.id.toString(),
                    "SubItemTable": [
                        {
                            "Class": selectedSubItem.class, 
                            "SubItem": selectedSubItem.subItem.replace("Sub ", "").padStart(2, "0")
                        }
                    ]
                };
            } else if (selectedCommodity.determinedBy === CommodityDeterminationType.DENSITY && selectedCommodity.subItems) {
                // Density-determined commodity - send all subItems
                request.Requests.Dimension.Class = {
                    "CommodityID": selectedCommodity.id.toString(),
                    "SubItemTable": selectedCommodity.subItems.map((item: SubItem) => ({
                        "Class": item.class,
                        "MinDensity": item.min,
                        "MaxDensity": item.max,
                        "SubItem": item.subItem.replace("Sub ", "").padStart(2, "0")
                    }))
                };
            } else if (selectedCommodity.classification && (!selectedCommodity.subItems || selectedCommodity.subItems.length === 0)) {
                // Commodity with classification number but no subitems
                request.Requests.Dimension.Class = {
                    "CommodityID": selectedCommodity.id.toString(),
                    "SubItemTable": [
                        {
                            "Class": selectedCommodity.classification,
                            "SubItem": ""
                        }
                    ]
                };
            }
        }
        return request;
    }

    // Check if the freight class is within the min/max limits set in the selected commodity
    const checkFreightClassLimits = useCallback((cargo: Cargo) => {
        // Skip check if no commodity is selected or no freight class in the cargo
        if (!selectedCommodity || !cargo.dimensions.freightClass || !cargo.dimensions.freightClass.class) {
            return;
        }

        // Parse the class value from the cargo response
        const freightClassValue = parseFloat(cargo.dimensions.freightClass.class);
        if (isNaN(freightClassValue)) {
            return;
        }

        // Check against min/max values if they exist
        let exceededMin = false;
        let exceededMax = false;
        let warningTranslationKey = "";
        let interpolationValues = {};

        if (selectedCommodity.minClass !== undefined && selectedCommodity.minClass !== null && 
            freightClassValue < selectedCommodity.minClass) {
            warningTranslationKey = "control.inputs.freightClassifier.warning.belowMinimum";
            interpolationValues = { value: freightClassValue, min: selectedCommodity.minClass };
            exceededMin = true;
            cargo.dimensions.freightClass.exceededMin = true;
        }

        if (selectedCommodity.maxClass !== undefined && selectedCommodity.maxClass !== null && 
            freightClassValue > selectedCommodity.maxClass) {
            warningTranslationKey = "control.inputs.freightClassifier.warning.aboveMaximum";
            interpolationValues = { value: freightClassValue, max: selectedCommodity.maxClass };
            exceededMax = true;
            cargo.dimensions.freightClass.exceededMax = true;
        }

        // Show alert if limits are exceeded
        if (warningTranslationKey) {
            openAlert(
                t("control.inputs.freightClassifier.warning.title"),
                t(warningTranslationKey, interpolationValues),
                t("alertContext.back"),
                () => { /* No specific action needed on OK */ },
                true,
                new Error("Freight class limit exceeded"),
                {
                    component: "Control",
                    action: "FreightClassValidation",
                    freightClassValue,
                    min: selectedCommodity.minClass,
                    max: selectedCommodity.maxClass,
                    exceededMin,
                    exceededMax
                }
            );
        }
    }, [selectedCommodity, openAlert, t]);

    const commands: { 
        [key: string]: (...args: any[]) => SpectreRequest 
    } = {
        dimension: (hasBarcode: boolean) => {
            const request: DimensionRequest = {
                "Requests": {
                    "SetOperatingUser": {
                        "Value": user || "Unknown User"
                    },
                    "Dimension": {
                        ...(hasBarcode && { "Barcode": barcodeValue }),
                        "CustomFields": encodeCustomFields()
                    },
                    "Snapshot": {},
                }
            };
            
            return addFreightClassToRequest(request);
        },
        upload: () => {
            return {
                "Requests": {
                    "Upload": {
                        "AutoShare": settingsLoaded && 'AutoShareOnUpload' in settings.Scanner ? settings.Scanner.AutoShareOnUpload.value : false
                    }
                }
            } as UploadRequest
        },
        export: () => {
            return {
                "Requests": {
                    "Export": {
                        "Endpoint": machine.settings.Export.Url.value,
                        "Format": machine.settings.Export.Format.value.toLowerCase(),
                        "Method": machine.settings.Export.Method.value.toLowerCase(),
                        "AuthHeader": machine.settings.Export.AuthHeader.value,
                        "FtpUsername": machine.settings.Export.Username.value,
                        "FtpPassword": machine.settings.Export.Password.value,
                        "AdditionalParameters": JSON.parse(machine.settings.Export.AdditionalParameters.value || '{}'),
                    }
                }
            } as ExportRequest
        },
        dimensionAndUpload: (hasBarcode: boolean) => {
            const request: DimensionAndUploadRequest = {
                "Requests": {
                    "SetOperatingUser": {
                        "Value": user || "Unknown User"
                    },
                    "Dimension": {
                        ...(hasBarcode && { "Barcode": barcodeValue }),
                        "CustomFields": encodeCustomFields()
                    },
                    "Snapshot": {},
                    "Upload": {
                        "AutoShare": settingsLoaded && 'AutoShareOnUpload' in settings.Scanner ? settings.Scanner.AutoShareOnUpload.value : false
                    }
                }
            };
            
            return addFreightClassToRequest(request);
        },
        uploadAndExport: () => {
            return {
                "Requests": {
                    "Upload": {
                        "AutoShare": settingsLoaded && 'AutoShareOnUpload' in settings.Scanner ? settings.Scanner.AutoShareOnUpload.value : false
                    },
                    "Export": {
                        "Endpoint": machine.settings.Export.Url.value,
                        "Format": machine.settings.Export.Format.value.toLowerCase(),
                        "Method": machine.settings.Export.Method.value.toLowerCase(),
                        "AuthHeader": machine.settings.Export.AuthHeader.value,
                        "FtpUsername": machine.settings.Export.Username.value,
                        "FtpPassword": machine.settings.Export.Password.value,
                        "AdditionalParameters": JSON.parse(machine.settings.Export.AdditionalParameters.value || '{}'),
                    }
                }
            } as UploadAndExportRequest
        },
        dimensionUploadAndExport: (hasBarcode: boolean) => {
            const request: DimensionUploadAndExportRequest = {
                "Requests": {
                    "SetOperatingUser": {
                        "Value": user || "Unknown User"
                    },
                    "Dimension": {
                        ...(hasBarcode && { "Barcode": barcodeValue }),
                        "CustomFields": encodeCustomFields()
                    },
                    "Snapshot": {},
                    "Upload": {
                        "AutoShare": settingsLoaded && 'AutoShareOnUpload' in settings.Scanner ? settings.Scanner.AutoShareOnUpload.value : false
                    },
                    "Export": {
                        "Endpoint": machine.settings.Export.Url.value,
                        "Format": machine.settings.Export.Format.value.toLowerCase(),
                        "Method": machine.settings.Export.Method.value.toLowerCase(),
                        "AuthHeader": machine.settings.Export.AuthHeader.value,
                        "FtpUsername": machine.settings.Export.Username.value,
                        "FtpPassword": machine.settings.Export.Password.value,
                        "AdditionalParameters": JSON.parse(machine.settings.Export.AdditionalParameters.value || '{}'),
                    }
                }
            };
            
            return addFreightClassToRequest(request);
        }
    }

    const styles = {
        scanHistory: {
            maxHeight: '80vh',
            overflow: "auto",
        },
        customFields: {
            overflow: "auto",
            maxHeight: {
                xs: '50vh',
                sm: '60vh',
                md: '75vh'
            }
        },
        centerControl: {
            maxHeight: '100vh',
            overflow: 'auto',
        }
    }

    // Handle freight class selection from Commodities component
    const handleFreightClassSelection = (commodity: Commodity, subItem: SubItem | null) => {
        setSelectedCommodity(commodity);
        setSelectedSubItem(subItem);
    };

    return (
        <div>
            <link rel="icon" href="data:,"></link>
            <Grid container direction="row" style={{
                minWidth: "100%",
                height: "100vh",
            }}>
                <Grid container item direction="column" justifyContent="space-between" md={6} sm={6} lg={3} xs={12}
                    sx={{
                        borderRight: '2px solid',
                        borderColor: '#D3D3DE',
                    }}>
                    <Inputs 
                        customFields={customFields} 
                        customFieldDropDownValues={customFieldDropDownValues} 
                        customFieldSubmitValues={customFieldSubmitValues} 
                        setCustomFieldSubmitValues={setCustomFieldSubmitValues}
                        setCustomFieldSubmitValuesEmpty={setCustomFieldSubmitValuesEmpty} 
                        customFieldsLoaded={customFieldsLoaded} 
                        barcodeValue={barcodeValue} 
                        setBarcodeValue={setBarcodeValue} 
                        machineActive={machineActive}
                        settings={settings} 
                        showMachineSettings={showMachineSettings} 
                        settingsLoaded={settingsLoaded} 
                        machineCommand={machineCommand} 
                        setMachineCommand={setMachineCommand} 
                        machineScan={machineScan}
                        scanButtonPressed={scanButtonPressed} 
                        setScanButtonPressed={setScanButtonPressed} 
                        disableScanButton={disableScanButton} 
                        setDisableScanButton={setDisableScanButton} 
                        cargoResponses={cargoResponses}
                        checkCustomFieldsReady={checkCustomFieldsReady} 
                        machine={machine} 
                        dimensionerMode={dimensionerMode} 
                        cargoResponse={cargoResponses} 
                        forklift={forklift} 
                        setOpenForkliftModal={setOpenForkliftModal} 
                        user={user}
                        commodities={commodities} 
                        commoditiesLoaded={commoditiesLoaded} 
                        onFreightClassSelected={handleFreightClassSelection}
                        drawerOpen={drawerOpen}
                        mobileNavbarOpen={mobileNavbarOpen}
                        pendingBarcode={pendingBarcode}
                        setPendingBarcode={setPendingBarcode}
                        clearPhotosSignal={clearPhotosSignal}
                        setMachineActive={setMachineActive}
                    ></Inputs>
                </Grid>
                <Grid item md={6} sm={6} xs={12} sx={styles.centerControl} display={{ xs: 'none', lg: 'block' }}>
                    <SelectForkliftModal open={openForkliftModal} setOpenForkliftModal={setOpenForkliftModal} forkliftList={forkliftList} setForklift={setForklift} machine={machine}></SelectForkliftModal>
                    <CenterControl 
                        showMachineSettings={showMachineSettings}
                        setShowMachineSettings={setShowMachineSettings}
                        machine={machine}
                        showCalibration={showCalibration}
                        setShowCalibration={setShowCalibration}
                        setClearCustomFieldsAfterUpload={setClearCustomFieldsAfterUpload}
                        setDisableScanButton={setDisableScanButton}
                        cargoResponse={cargoResponses[selectedScanIndex]}
                        selectedScanIndex={selectedScanIndex}
                        settings={settings}
                        setSettings={setSettings}
                        setSettingsLoaded={setSettingsLoaded}
                        showSupport={showSupport}
                        setShowSupport={setShowSupport}
                        showCertification={showCertification}
                        setShowCertification={setShowCertification}
                        openScanDetails={openScanDetails}
                        setOpenScanDetails={setOpenScanDetails}
                        handleReupload={handleReupload}
                        handleRexport={handleRexport}
                    />
                </Grid>
                <Grid item lg={3} style={{ paddingTop: 67 }} sx={{ backgroundColor: "#F5F5F8", display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }} >
                <Grid item lg={12} style={{ backgroundColor: '#EAEAF0' }} sx={{
                        borderBottom: '2px solid',
                        borderColor: '#D3D3DE',
                    }}>
                        <Typography variant="h6" color="#4B4E65">{t('control.eventHistory.title')}</Typography>
                    </Grid>
                    <Grid sx={styles.scanHistory}>
                        <ScanHistory selectedScanIndex={selectedScanIndex} setSelectedScanIndex={setSelectedScanIndex} cargoResponses={cargoResponses}
                            setOpenScanDetails={setOpenScanDetails} machine={machine} machineEvents={machineEvents}
                        />
                    </Grid>
                </Grid>
                <Grid item md={6} sm={6} style={{ paddingTop: 67 }} sx={{ backgroundColor: "#F5F5F8", display: { xs: 'none', sm: 'block', md: 'block', lg: 'none' } }} >
                    <Grid item md={12} style={{ backgroundColor: '#EAEAF0' }} sx={{
                        borderBottom: '2px solid',
                        borderColor: '#D3D3DE',
                    }}>
                        <Typography variant="h6" color="#4B4E65">{t('control.eventHistory.title')}</Typography>
                    </Grid>
                    <Grid sx={styles.scanHistory}>
                        <ScanHistoryMobile selectedScanIndex={selectedScanIndex} setSelectedScanIndex={setSelectedScanIndex} cargoResponses={cargoResponses}
                            setOpenScanDetails={setOpenScanDetails} machine={machine} machineEvents={machineEvents} open={false}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid display={{ xs: 'block', sm: 'none' }}>
                <ScanHistoryDrawer 
                    selectedScanIndex={selectedScanIndex} 
                    setSelectedScanIndex={setSelectedScanIndex} 
                    cargoResponses={cargoResponses}
                    setOpenScanDetails={setOpenScanDetails} 
                    machine={machine} 
                    machineEvents={machineEvents}
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                ></ScanHistoryDrawer>
            </Grid>
        </div>
    )
}